import { MenuItemsType, DropdownMenuItemType } from '@pancakeswap/uikit'
import { ContextApi } from 'contexts/Localization/types'
import { nftsBaseUrl } from 'views/Nft/market/constants'

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

const config: (t: ContextApi['t']) => ConfigMenuItemsType[] = (t) => [
  {
    label: t('Trade'),
    icon: 'Swap',
    href: '/swap',
    showItemsOnMobile: false,
    items: [
      {
        label: t('Exchange'),
        href: '/swap',
      },
      {
        label: t('Liquidity'),
        href: '/liquidity',
      },
    ],
  },
  {
    label: t('Earn'),
    href: '/farms',
    icon: 'Earn',
    showItemsOnMobile: false,
    items: [
      {
        label: t('Farms'),
        href: '/farms',
      },
      {
        label: t('Pools'),
        href: '/pools',
      },
    ],
  },

  {
    label: t('Launchpad'),
    href: '/launchpad',
    icon: 'Ifo',
    showItemsOnMobile: false,
    items:[
      {
        label: t('Buy'),
        href: '/launchpad',
      },
      {
        label: t('Create token'),
        href: '/createtoken',
      },
      {
        label: t('Create launchpad'),
        href: '/createpad',
      },
      {
        label: t('Create fair launch'),
        href: '/createfair',
      },
      {
        label: t('Launchpad list'),
        href: '/padlist',
      },
    ]
  },

  {
    label: t('MarketPlace'),
    href: '/marketplace',
    icon: 'Earn',
    showItemsOnMobile: false,
    items: [
      {
        label: t('Home'),
        href: '/marketplace',
      },
      {
        label: t('Collections'),
        href: '/collections',
      },
      {
        label: t('NFTs'),
        href: '/nfts',
      },
    ],
  },
  
]

export default config
